/* Avena Cloud Pillow v2 — page interaction.
   Self-contained, no dependencies, no third-party or reference-origin calls.
   Every behaviour degrades to a working page if JS fails: the form posts to
   /cart/add, the slides are a native scroll-snap rail, the reviews are real DOM.
*/
(function () {
  'use strict';

  var root = document.querySelector('.af2');
  if (!root) return;

  var $ = function (s, c) { return (c || root).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); };

  /* ------------------------------------------------------------- gallery */
  (function gallery() {
    var rail = $('[data-af2-slides]');
    if (!rail) return;
    var figs = $$('figure', rail);
    var thumbs = $$('button', $('[data-af2-thumbs]'));
    var prev = $('[data-af2-prev]');
    var next = $('[data-af2-next]');
    var i = 0;

    function go(n) {
      i = Math.max(0, Math.min(figs.length - 1, n));
      rail.scrollTo({ left: figs[i].offsetLeft - rail.offsetLeft, behavior: 'smooth' });
      paint();
    }
    function paint() {
      thumbs.forEach(function (t, n) { t.classList.toggle('is-on', n === i); });
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === figs.length - 1;
    }
    if (prev) prev.addEventListener('click', function () { go(i - 1); });
    if (next) next.addEventListener('click', function () { go(i + 1); });
    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { go(n); }); });

    var tick;
    rail.addEventListener('scroll', function () {
      clearTimeout(tick);
      tick = setTimeout(function () {
        var mid = rail.scrollLeft + rail.clientWidth / 2;
        var best = 0, bd = Infinity;
        figs.forEach(function (f, n) {
          var c = f.offsetLeft - rail.offsetLeft + f.clientWidth / 2;
          var d = Math.abs(c - mid);
          if (d < bd) { bd = d; best = n; }
        });
        i = best; paint();
      }, 90);
    }, { passive: true });
    paint();
  })();

  /* --------------------------------------------------------- ships-by date
     Next business day, written the way a person would say it. Computed in the
     visitor's own clock so it can never read as a stale hard-coded date. */
  (function shipDate() {
    var el = $('[data-af2-ship]');
    if (!el) return;
    var d = new Date();
    d.setDate(d.getDate() + 1);
    while (d.getDay() === 0 || d.getDay() === 6) d.setDate(d.getDate() + 1);
    el.textContent = d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
  })();

  /* -------------------------------------------------------------- buy box */
  var cards = $$('[data-af2-card]');
  var form = $('[data-af2-form]');
  var status = $('[data-af2-status]');
  var fallback = $('[data-af2-fallback]');
  var current = cards.filter(function (c) { return c.classList.contains('is-sel'); })[0] || cards[0];

  // Every variant this page can add — used to clear OUR previous lines before
  // adding a new one, so a second click never silently stacks two bundles.
  // Only our ids are touched; anything else in the cart is left alone.
  var owned = [];
  cards.forEach(function (c) {
    owned.push(c.getAttribute('data-variant'));
    (c.getAttribute('data-gifts') || '').split(',').forEach(function (g) {
      if (g && owned.indexOf(g) === -1) owned.push(g);
    });
    var cs = c.getAttribute('data-case');
    if (cs && owned.indexOf(cs) === -1) owned.push(cs);
  });

  /* Cooling-case upsell row inside each pack card (pre-ticked). The row is a span inside the pack <label>,
     so the browser does not toggle it for us: drive the checkbox ourselves and stop the label re-firing. */
  function caseOn(card) {
    var row = $('[data-af2-case-row]', card);
    return !!row && row.getAttribute('aria-checked') === 'true';
  }
  function totalFor(card) {
    if (!card) return '';
    return caseOn(card) ? card.getAttribute('data-combined') : card.getAttribute('data-total');
  }
  function paintTotals() {
    var t = totalFor(current);
    var at = $('[data-af2-atot]'); if (at) at.textContent = t;
    var pr = $('[data-af2-stprice]'); if (pr) pr.textContent = t;
  }
  $$('[data-af2-case-row]').forEach(function (row) {
    function flip(e) {
      e.preventDefault(); e.stopPropagation();
      var on = row.getAttribute('aria-checked') !== 'true';
      row.setAttribute('aria-checked', on ? 'true' : 'false');
      var cb = $('[data-af2-case-input]', row); if (cb) cb.checked = on;
      var card = row.closest('[data-af2-card]');
      if (card) select(card); else paintTotals();
    }
    row.addEventListener('click', flip);
    row.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') flip(e); });
  });

  function select(card) {
    current = card;
    cards.forEach(function (c) { c.classList.toggle('is-sel', c === card); });
    var input = $('input', card);
    if (input) input.checked = true;
    var img = $('[data-af2-stimg]'), nm = $('[data-af2-stname]'), pr = $('[data-af2-stprice]');
    if (img) img.src = card.getAttribute('data-img');
    if (nm) nm.textContent = card.getAttribute('data-name');
    if (pr) pr.textContent = totalFor(card);
    paintTotals();
  }
  cards.forEach(function (c) {
    c.addEventListener('click', function () { select(c); });
    c.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); select(c); }
    });
  });
  if (current) select(current);

  var busy = false;

  function addToCart(btn) {
    if (busy || !current) return;
    busy = true;
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.textContent = 'ADDING…'; }
    if (status) { status.hidden = false; status.textContent = 'Adding your bundle…'; }
    if (fallback) fallback.hidden = true;

    var items = [{ id: Number(current.getAttribute('data-variant')), quantity: 1 }];
    (current.getAttribute('data-gifts') || '').split(',').forEach(function (g) {
      if (g) items.push({ id: Number(g), quantity: 1, properties: { _free_gift: 'yes' } });
    });
    if (caseOn(current) && current.getAttribute('data-case')) {
      items.push({ id: Number(current.getAttribute('data-case')), quantity: 1 });
    }

    var updates = {};
    owned.forEach(function (id) { updates[id] = 0; });

    /* The buy button opens the theme's SLIDE-OUT CART, never checkout directly
       (founder, 2026-09-26; R-040). The drawer's own Checkout button carries the
       Sticky.io hand-off, so the drawer is the one path that keeps upsells,
       gift logic and checkout all owned by the theme. */
    var drawer = document.querySelector('cart-drawer');
    var sectionIds = [];
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      sectionIds = drawer.getSectionsToRender().map(function (s) { return s.section || s.id; });
    }
    var addBody = { items: items };
    if (sectionIds.length) {
      addBody.sections = sectionIds.join(',');
      addBody.sections_url = window.location.pathname;
    }

    var post = function (url, body) {
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body),
        credentials: 'same-origin'
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || 'Cart error'); });
        return r.json();
      });
    };

    post('/cart/update.js', { updates: updates })
      .then(function () { return post('/cart/add.js', addBody); })
      .then(function (data) {
        if (drawer && typeof drawer.renderContents === 'function' && data && data.sections) {
          if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
          drawer.renderContents(data);           // theme re-renders and opens itself
          if (!drawer.classList.contains('active') && typeof drawer.open === 'function') drawer.open(btn);
        } else if (drawer && typeof drawer.open === 'function') {
          drawer.classList.remove('is-empty');
          drawer.open(btn);
        } else {
          window.location.href = '/cart';        // no drawer on this layout: cart page, never checkout
          return;
        }
        busy = false;
        if (btn) { btn.disabled = false; btn.innerHTML = label; }
        if (status) status.hidden = true;
      })
      .catch(function (err) {
        busy = false;
        if (btn) { btn.disabled = false; btn.innerHTML = label; }
        if (status) status.textContent = (err && err.message) ? err.message : 'Something went wrong adding that.';
        if (fallback) fallback.hidden = false;
      });
  }

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      addToCart($('.af2-atc', form));
    });
  }
  var stbtn = $('[data-af2-stbtn]');
  if (stbtn) stbtn.addEventListener('click', function () { addToCart(stbtn); });

  var jump = $('[data-af2-jump]');
  if (jump && form) {
    jump.addEventListener('click', function () {
      form.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  /* ------------------------------------------- what to expect: illuminate
     The reference lights each step as it reaches the middle of the screen and
     runs a fill down the rail behind them. Same behaviour, rebuilt: an
     IntersectionObserver with a band around the viewport centre for the steps,
     and a rAF-throttled scroll handler for the fill height. */
  (function timeline() {
    var tl = $('[data-af2-tl]');
    if (!tl) return;
    var steps = $$('[data-af2-step]', tl);
    var track = $('[data-af2-track]', tl);
    var fill = $('[data-af2-fill]', tl);
    if (!steps.length) return;

    function geometry() {
      var first = $('[data-af2-node]', steps[0]);
      var last = $('[data-af2-node]', steps[steps.length - 1]);
      if (!first || !last || !track || !fill) return null;
      // Measure against the RAIL, not against each step. The nodes are
      // absolutely positioned inside their own step, so offsetTop is relative
      // to that step and is ~0 for every one of them — rects are the only
      // honest measure here.
      var base = tl.getBoundingClientRect().top;
      var fr = first.getBoundingClientRect();
      var lr = last.getBoundingClientRect();
      var top = (fr.top - base) + fr.height / 2;
      var bottom = (lr.top - base) + lr.height / 2;
      track.style.top = top + 'px';
      track.style.height = (bottom - top) + 'px';
      fill.style.top = top + 'px';
      return { top: top, height: bottom - top };
    }
    var geo = geometry();

    if ('IntersectionObserver' in window) {
      tl.classList.add('is-ready');   // only now is dimming safe
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) en.target.classList.add('is-on');
        });
      }, { rootMargin: '-42% 0px -42% 0px', threshold: 0 });
      steps.forEach(function (s) { io.observe(s); });
    } else {
      steps.forEach(function (s) { s.classList.add('is-on'); });
    }

    var queued = false;
    function paintFill() {
      queued = false;
      if (!geo) geo = geometry();
      if (!geo) return;
      var r = tl.getBoundingClientRect();
      var mid = window.innerHeight * 0.55;
      var progress = (mid - (r.top + geo.top)) / geo.height;
      fill.style.height = Math.max(0, Math.min(1, progress)) * geo.height + 'px';
    }
    function onScroll() {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(paintFill);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { geo = geometry(); paintFill(); });
    paintFill();
  })();

  /* ------------------------------------------------------ review paging */
  (function reviews() {
    var pager = $('[data-af2-pager]');
    if (!pager) return;
    var pages = $$('[data-af2-page]');
    var btns = $$('button', pager);
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        var want = b.getAttribute('data-af2-go');
        pages.forEach(function (p) { p.hidden = p.getAttribute('data-af2-page') !== want; });
        btns.forEach(function (o) { o.classList.toggle('is-on', o === b); });
        var head = document.getElementById('af2-reviews');
        if (head) head.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  })();

  /* Write a review — present and styled, intentionally inert (founder note).
     It is a <button>, never an <a>, so it cannot navigate anywhere. */
  var write = $('[data-af2-write]');
  if (write) write.addEventListener('click', function (e) { e.preventDefault(); });

  /* Rating row under the gallery scrolls to the review widget. */
  var toRev = $('[data-af2-toreviews]');
  if (toRev) toRev.addEventListener('click', function (e) {
    var target = document.getElementById('af2-reviews');
    if (!target) return;
    e.preventDefault();
    var y = target.getBoundingClientRect().top + window.pageYOffset - 12;
    window.scrollTo({ top: y, behavior: 'smooth' });
  });

  /* --------------------------------------------------------- sticky bar */
  (function sticky() {
    var bar = $('[data-af2-sticky]');
    var atc = $('.af2-atc');
    if (!bar || !atc) return;
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (e) {
        bar.classList.toggle('is-on', !e[0].isIntersecting && e[0].boundingClientRect.top < 0);
      }, { threshold: 0 });
      io.observe(atc);
    }
  })();
})();
